import React from "react"

const FreeDomainServices = () => {
  return (
    <>
      <section className="free-domain-services">
        <div className="container-xl">
          <div className="free-services">
            <h2 className="component-title d-inline-block ui-heading">
              FREE Add-ons with every Domain Name!
            </h2>
            <p className="fea-heading mb-4">
              Unlock Incredible Value: Get Over ₹5000 Worth of Free Services
              with Every Domain Registration!
            </p>
            <div className="row feature-wrapper">
              <div className="col-12 col-lg-6">
                <div className="feature-block">
                  <h3 className="title">Free Web Hosting *</h3>
                  <div className="description">
                    <ul>
                      <li>250 MB of SSD storage</li>
                      <li>Shared RAM and vCPU resources</li>
                      <li>Weekly malware scans</li>
                      <li>Automatic data backup</li>
                    </ul>
                  </div>
                  <img src="/img/vendors/Logo_Plesk.svg" alt="" />
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="feature-block">
                  <h3 className="title">Free Email Account</h3>
                  <div className="description">
                    You'll receive two personalized email addresses, like
                    sales@yourdomain.com, inclusive of free protection against
                    fraud, spam, and viruses.
                  </div>
                  <img src="/img/svg/email.svg" alt="" />
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="feature-block">
                  <h3 className="title">Free SSL Certificates</h3>
                  <div className="description">
                    Supported by Let's Encrypt, every SSL Certificate we offer
                    contributes to safeguarding your websites and emails. This
                    ensures the protection of personal information and other
                    sensitive data.
                  </div>
                  <img
                    src="/img/svg/le-logo-standard.svg"
                    alt="Free SSL Certificates"
                  />
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="feature-block">
                  <h3 className="title">DNS Management</h3>
                  <div className="description">
                    Access our lifetime complimentary DNS service, empowering
                    you to oversee your DNS records on our extensively
                    distributed and exceptionally resilient DNS infrastructure.
                  </div>
                  <img src="/img/icons/dns.png" alt="" />
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="feature-block">
                  <h3 className="title">Free Mail Forwards</h3>
                  <div className="description">
                    Set up complimentary email forwards to automatically
                    redirect your emails to existing email accounts.
                  </div>
                  <img src="/img/icons/free-fwd.png" alt="" />
                </div>
              </div>

              <div className="col-12 col-lg-6">
                <div className="feature-block">
                  <h3 className="title">Domain Forwarding</h3>
                  <div className="description">
                    Easily direct your domain name to another website at no
                    cost! Redirect users seamlessly when they enter your domain
                    name into a browser, with or without domain masking, while
                    ensuring optimal SEO performance.
                  </div>
                  <img src="/img/icons/domain.png" alt="" />
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="feature-block">
                  <h3 className="title">Domain Theft Protection</h3>
                  <div className="description">
                    Safeguard your domain from accidental or unauthorized
                    transfers with our complimentary Domain Theft Protection
                    service.
                  </div>
                  <img src="/img/icons/protection.png" alt="" />
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="feature-block">
                  <h3 className="title">Easy to use Control Panel</h3>
                  <div className="description">
                    Utilize our user-friendly Control Panel to efficiently
                    manage your domain name, configure email accounts, renew
                    your domain, and purchase additional services.
                  </div>
                  <img src="/img/vendors/Logo_Plesk.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default FreeDomainServices
